import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import RecalProposalSetContMain from "presentation/view/container/RecalProposalSet/RecalProposalSetContMain";

CommonEntrypoint(<RecalProposalSetContMain/>)